// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3xOtx","dragIcon":"Choice_dragIcon__EghmE","left":"Choice_left__3oVPO","input":"Choice_input__1pM4u"};